import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { TitleModel } from '../models/title.model';
 
@Injectable({ providedIn: 'root' })
export class MessageService {
    private filter = new Subject<any>();
    private error = new Subject<any>();
    private goodMessage = new Subject<any>();
    private selectedActivity = new Subject<any>();
    private selectedActivityAfterOps = new Subject<any>();
    private clickedSave = new Subject<any>();
    private madeChanges = new Subject<any>();
    private canceledChanges = new Subject<any>();
    private opSequenceChanged = new Subject<any>();
    private selectedActivityTitle = new Subject<any>();
    private showOldChanged = new Subject<any>();

    // Send message with filter selection when user clicks on "apply filter"
    // If any of the grids return an error
    sendErrorMessage(message: string) {
        this.error.next({ message });
    }
 
    clearErrorMessage() {
        this.error.next();
    }
 
    getErrorMessage(): Observable<any> {
        return this.error.asObservable();
    }

    // Feedback successful messages
    sendSuccessMessage(message: string) {
        this.goodMessage.next({ message });
    }
 
    clearSuccessMessage() {
        this.goodMessage.next();
    }
    getSuccessMessage(): Observable<any> {
        return this.goodMessage.asObservable();
    }

    // When the user clicks on a different activity - broadcast to all child grids
    sendSelectedActivityTitleChangeMessage(title: TitleModel) {
        this.selectedActivityTitle.next({ title });
    }
 
    clearSelectedActivityTitleChangeMessage() {
        this.selectedActivityTitle.next();
    }
 
    getSelectedActivityTitleChangeMessage(): Observable<any> {
        return this.selectedActivityTitle.asObservable();
    }
    
}